import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartModel } from '../../../models/cart-product-model';
import { CartService } from '../../../services/cart.service';
import { CouponService } from '../../../services/coupon.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrl: './cart.component.scss',
  standalone: false,
})
export class CartComponent {
  public currentScreen: 'cart' | 'success' | 'formular' = 'cart';
  public boughtCouponAmount: number;
  public items: CartModel[] = [];
  public isLoading = true;

  constructor(
    private router: Router,
    public cartService: CartService,
    public userService: UserService,
    public location: Location,
    private activatedRoute: ActivatedRoute,
    private couponService: CouponService
  ) {}

  public ngOnInit() {
    this.getCartItems();
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['tab']) {
        this.currentScreen = params['tab'];
      } else {
        this.currentScreen = 'cart';
      }
    });
  }

  private async getCartItems(): Promise<void> {
    this.couponService.getAllSellableCoupons().subscribe({
      next: coupons => {
        const items = this.cartService.items.map(item => {
          const coupon = coupons.find(c => c.id === item.product.id);
          return {
            amount: item.amount,
            product: coupon,
          };
        });
        this.cartService.updateCart(items);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  getTotalAmount(): number {
    return this.items.reduce((acc, item) => {
      return acc + item.amount * item.product.payedAmount;
    }, 0);
  }

  public changeAmount(item: CartModel): void {
    this.cartService.changeAmount(item);
  }

  public removeFromCart(item: CartModel): void {
    this.cartService.removeItem(item);
  }

  public toInvoiceFormular(): void {
    this.router.navigate([], {
      queryParams: { tab: 'formular' },
    });
  }

  public toLogin() {
    this.router.navigate(['/login'], {
      queryParams: { redirectUrl: this.location.path() },
    });
  }
}
